import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditBlogTag from "../../components/blog-tags/FormAddEditBlogTag";
import { useGetBlogTag } from "../../hooks/blog-tags/useGetBlogTag";
import LoadingPage from "../../components/global/LoadingPage";

const EditBlogTag = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, tag } = useGetBlogTag(id);

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/blog/tags");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditBlogTag isEdit={true} currentData={tag} onSubmitSuccess={handleSuccess} />
        </WrapperSection>
    );
};

export default EditBlogTag;
